import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchClaimNotes } from '../data-provider/claim-notes';
import type { ClaimNotesResponse, GetClaimNotesRequestParams } from '../data-provider/claim-notes/api';

export interface UseGetClaimNotesParams {
  claimKey: number | undefined;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export const useGetClaimNotes = ({
  claimKey,
  pageSize = 10,
  sortColumn = 'SequenceNo',
  sortDirection = 'DESC',
}: UseGetClaimNotesParams) => {
  return useInfiniteQuery<ClaimNotesResponse>({
    enabled: Boolean(claimKey),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => {
      const params: GetClaimNotesRequestParams = {
        claimKey: Number(claimKey),
        pageIndex: Number(pageParam),
        pageSize,
        sortColumn,
        sortDirection,
      };
      return fetchClaimNotes(params);
    },
    queryKey: ['claims-loss-and-damage-notes', claimKey, sortColumn, sortDirection],
    select: (data) => {
      const notes = data.pages.flatMap((page) => page?.data ?? []);
      const lastPage = data.pages[data.pages.length - 1];
      const pageIndex = data.pages.length;

      return {
        ...data,
        notes,
        pageIndex,
        totalRows: Number(lastPage?.totalRows ?? 0),
      };
    },
  });
};
